/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { HLabel } from 'components/HLabel'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'

import { RegulacaoItem, RegulacaoModalItemProps } from './RegulacaoItem'

const NAO_INFORMADO_TEXT = 'Não informado'

export const RegulacaoModalItemSolicitacaoExame = (props: Readonly<RegulacaoModalItemProps>) => {
  const { item } = props
  const { lotacao, tipoRegulacao } = item
  const { dataSolicitacao, solicitacao, exame, observacao } = item.exame
  const solicitanteLabel = [
    lotacao.profissional.nome,
    lotacao.cbo.nome,
    lotacao.equipe?.nome ?? 'Sem equipe',
    lotacao.unidadeSaude.nome,
  ]
    .filterNotNull()
    .join(' | ')

  return (
    <VFlow vSpacing={0.5}>
      <RegulacaoItem title='CID 10' subtitle={solicitacao.cid10?.nome ?? '-'} />
      <RegulacaoItem title='Justificativa do procedimento' subtitle={solicitacao.justificativa ?? NAO_INFORMADO_TEXT} />
      <RegulacaoItem title='Observações' subtitle={solicitacao.observacoes ?? NAO_INFORMADO_TEXT} />
      <RegulacaoItem title='Data de solicitação' subtitle={formatDate(dataSolicitacao)} />
      <RegulacaoItem title='Solicitante' subtitle={solicitanteLabel} />
      <VFlow vSpacing={0}>
        <Heading level={3}>
          {tipoRegulacao === TipoRegulacaoEnum.SOLICITACAO_EXAME_OCI ? 'Procedimento' : 'Exame'}
        </Heading>
        <Box style={styles.box}>
          <VFlow vSpacing={0}>
            <HFlow hSpacing={0.25}>
              <Text fontWeight='bold'>{exame.descricao}</Text> - {exame.codigo}
            </HFlow>
            <HLabel title='Observação:' style={styles.observacao}>
              {observacao ?? NAO_INFORMADO_TEXT}
            </HLabel>
          </VFlow>
        </Box>
      </VFlow>
    </VFlow>
  )
}

const styles = {
  box: css`
    padding: 0.5rem;
    margin-top: 0.5rem;
  `,
  observacao: css`
    word-break: break-word;
  `,
}
